// UX & CRO Assessment — Landing Page JS
// 3-step in-card flow: URL input → Loader → Email gate → Redirect

function initUxLanding() {
  const urlForm    = document.querySelector("#ux-url-form");
  if (!urlForm) return;
  if (urlForm.dataset.uxBound) return;
  urlForm.dataset.uxBound = "true";

  const urlInput    = document.querySelector("#ux-url");
  const urlSubmit   = document.querySelector("#ux-url-submit");
  const urlError    = document.querySelector("#ux-url-error");
  const stepUrl     = document.querySelector("#ux-step-url");
  const stepLoader  = document.querySelector("#ux-step-loader");
  const stepEmail   = document.querySelector("#ux-step-email");
  const loaderPhrase = document.querySelector("#ux-loader-phrase");
  const emailForm   = document.querySelector("#ux-email-form");
  const emailInput  = document.querySelector("#ux-email");
  const emailSubmit = document.querySelector("#ux-email-submit");
  const emailError  = document.querySelector("#ux-email-error");

  const PHRASES = [
    "Controllo della gerarchia visiva...",
    "Test di chiarezza delle Call to Action...",
    "Analisi dei pattern di lettura...",
    "Verifica del carico cognitivo...",
    "Calcolo finale dell'UX & CRO Score..."
  ];

  let phraseInterval = null;
  let capturedToken  = null;

  function startPhrases() {
    let idx = 0;
    if (loaderPhrase) loaderPhrase.textContent = PHRASES[0];
    phraseInterval = setInterval(() => {
      idx = (idx + 1) % PHRASES.length;
      if (loaderPhrase) loaderPhrase.textContent = PHRASES[idx];
    }, 2800);
  }

  function stopPhrases() {
    clearInterval(phraseInterval);
    phraseInterval = null;
  }

  function showState(activeEl) {
    [stepUrl, stepLoader, stepEmail].forEach(el => {
      if (el) el.hidden = (el !== activeEl);
    });
  }

  function isValidUrl(str) {
    try {
      const u = new URL(str);
      return (u.protocol === "http:" || u.protocol === "https:") && u.hostname.includes(".");
    } catch {
      return false;
    }
  }

  if (urlInput) {
    urlInput.addEventListener("input", () => {
      const val = urlInput.value.trim();
      if (!val) {
        urlInput.classList.remove("ux-input--error", "ux-input--ok");
        if (urlError) { urlError.hidden = true; urlError.textContent = ""; }
      } else if (isValidUrl(val)) {
        urlInput.classList.add("ux-input--ok");
        urlInput.classList.remove("ux-input--error");
        if (urlError) { urlError.hidden = true; urlError.textContent = ""; }
      } else {
        urlInput.classList.add("ux-input--error");
        urlInput.classList.remove("ux-input--ok");
      }
    });
  }

  // ── Step 1: URL form submit ─────────────────────────────────────────────────

  urlForm.addEventListener("submit", async (e) => {
    e.preventDefault();

    const url = urlInput?.value?.trim();
    if (!isValidUrl(url)) {
      if (urlInput) { urlInput.classList.add("ux-input--error"); urlInput.classList.remove("ux-input--ok"); }
      if (urlError) { urlError.hidden = false; urlError.textContent = "Inserisci un URL valido che inizi con https://"; }
      urlInput?.focus();
      return;
    }

    if (urlInput) { urlInput.classList.remove("ux-input--error"); urlInput.classList.add("ux-input--ok"); }
    if (urlError) { urlError.hidden = true; urlError.textContent = ""; }
    if (urlSubmit) urlSubmit.disabled = true;

    showState(stepLoader);
    startPhrases();

    try {
      const response = await fetch("/ux_assessments/stream", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""
        },
        body: JSON.stringify({ lead: { url } })
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        const details = (data.errors || []).concat([data.error || ""]).filter(Boolean).join(" ");
        throw new Error(details || "Errore durante l'analisi. Riprova tra poco.");
      }

      capturedToken = data.token;

      // Poll until the background job completes
      const POLL_INTERVAL_MS = 3000;
      const MAX_POLL_ATTEMPTS = 80; // ~4 minutes
      const csrf = document.querySelector("meta[name='csrf-token']")?.content || "";

      for (let attempt = 0; attempt < MAX_POLL_ATTEMPTS; attempt++) {
        await new Promise(r => setTimeout(r, POLL_INTERVAL_MS));
        const pollRes = await fetch(`/ux_assessments/${capturedToken}.json`, {
          headers: { "X-CSRF-Token": csrf }
        });
        if (!pollRes.ok) throw new Error("Errore nel controllo dell'analisi.");
        const result = await pollRes.json().catch(() => ({}));
        if (result.status === "completed") break;
        if (result.status === "failed") throw new Error(result.error || "Errore durante l'analisi.");
        if (attempt === MAX_POLL_ATTEMPTS - 1) throw new Error("Timeout: l'analisi ha impiegato troppo tempo. Riprova.");
      }

      stopPhrases();
      showState(stepEmail);
      if (emailInput) emailInput.focus();

    } catch (err) {
      stopPhrases();
      const msg = err.message || "Errore imprevisto. Riprova tra poco.";
      showState(stepUrl);
      if (urlError) { urlError.textContent = msg; urlError.hidden = false; }
      if (urlSubmit) urlSubmit.disabled = false;
    }
  });

  // ── Step 3: Email form submit ───────────────────────────────────────────────

  if (emailForm) {
    emailForm.addEventListener("submit", async (e) => {
      e.preventDefault();

      const email = emailInput?.value?.trim();
      if (!email) return;

      if (emailError) { emailError.hidden = true; emailError.textContent = ""; }
      if (emailSubmit) emailSubmit.disabled = true;

      if (!capturedToken) {
        if (emailError) { emailError.textContent = "Sessione scaduta. Ricarica la pagina e riprova."; emailError.hidden = false; }
        if (emailSubmit) emailSubmit.disabled = false;
        return;
      }

      try {
        const response = await fetch(`/ux_assessments/${capturedToken}/claim`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""
          },
          body: JSON.stringify({ lead: { email } })
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(data.error || "Errore. Riprova tra poco.");
        }

        window.location.href = data.redirect_url;

      } catch (err) {
        if (emailError) { emailError.textContent = err.message || "Errore. Riprova tra poco."; emailError.hidden = false; }
        if (emailSubmit) emailSubmit.disabled = false;
      }
    });
  }
}

document.addEventListener("turbo:load", initUxLanding);
